const FREE_MAX = 3;
const PREMIUM_MAX = 100;
const FREE_KEY = 'freeSearchCount';
const PREMIUM_KEY = 'premiumSearchCount';
const PREMIUM_FLAG = 'isPremiumUser';

export const isPremiumUser = () => localStorage.getItem(PREMIUM_FLAG) === 'true';
export const setPremiumUser = () => localStorage.setItem(PREMIUM_FLAG, 'true');

export const resetSearchCount = () => {
  if (isPremiumUser()) {
    localStorage.setItem(PREMIUM_KEY, '0');
  } else {
    localStorage.setItem(FREE_KEY, '0');
  }
};

export const getRemainingSearches = () => {
  if (isPremiumUser()) {
    const count = parseInt(localStorage.getItem(PREMIUM_KEY) || '0', 10);
    return PREMIUM_MAX - count;
  } else {
    const count = parseInt(localStorage.getItem(FREE_KEY) || '0', 10);
    return FREE_MAX - count;
  }
};

export const incrementSearchCount = () => {
  if (isPremiumUser()) {
    const count = parseInt(localStorage.getItem(PREMIUM_KEY) || '0', 10) + 1;
    localStorage.setItem(PREMIUM_KEY, count);
  } else {
    const count = parseInt(localStorage.getItem(FREE_KEY) || '0', 10) + 1;
    localStorage.setItem(FREE_KEY, count);
  }

  // Dispatch event to notify components that search count has changed
  window.dispatchEvent(new CustomEvent('searchCountUpdated'));
};

export const hasReachedLimit = () => getRemainingSearches() <= 0;

const searchLimitService = {
  isPremiumUser,
  setPremiumUser,
  getRemainingSearches,
  incrementSearchCount,
  hasReachedLimit,
  resetSearchCount
};

export default searchLimitService;
